import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import AuthService from './services/auth';
import Login from './components/Login';
import TopNavbar from './components/TopNavbar';
import Dashboard from './components/Dashboard';
import AssetTypes from './components/AssetTypes';
import Assets from './components/Assets';
import Employees from './components/Employees';
import AssetAssignments from './components/AssetAssignments';
import Repairs from './components/Repairs';
import Departments from './components/Departments';
import Discoms from './components/Discoms';
import Vendors from './components/Vendors';
import Users from './components/Users';
import AiSearchChat from './components/AiSearchChat';
import AuditLogs from './components/AuditLogs';
import RepairAnalytics from './components/RepairAnalytics';
import Help from './components/Help';
import Footer from './components/Footer';
import Loader from './components/Loader';
import ReceiptVerification from './components/ReceiptVerification';
import './components/Loader.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
}

function AppContent() {
  const { login, hasPermission } = useAuth();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const currentUser = AuthService.getCurrentUser();
    if (currentUser) {
      setUser(currentUser);
      AuthService.setupAxiosInterceptors();
    }
    setTimeout(() => setLoading(false), 500);
  }, []);

  const handleLogin = () => {
    const currentUser = AuthService.getCurrentUser();
    setUser(currentUser);
    login(currentUser);
  };

  const handleLogout = () => {
    AuthService.logout();
    setUser(null);
  };

  if (loading) {
    return <Loader overlay={true} text="Initializing Saral Asset Manager..." size="large" />;
  }

  if (window.location.pathname.startsWith('/receipt-verification/')) {
    return (
      <Router>
        <Routes>
          <Route path="/receipt-verification/:receiptNumber" element={<ReceiptVerification />} />
        </Routes>
      </Router>
    );
  }

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Router>
      <div className="d-flex flex-column" style={{height: '100vh', overflow: 'hidden'}}>
        <TopNavbar onLogout={handleLogout} user={user} />
        <div className="main-content flex-grow-1" style={{overflow: 'auto', minHeight: 0}}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            {hasPermission('canManageAssets') && <Route path="/asset-types" element={<AssetTypes />} />}
            {hasPermission('canManageAssets') && <Route path="/departments" element={<Departments />} />}
            {hasPermission('canManageAssets') && <Route path="/discoms" element={<Discoms />} />}
            {hasPermission('canManageAssets') && <Route path="/vendors" element={<Vendors />} />}
            {hasPermission('canManageAssets') && <Route path="/assets" element={<Assets />} />}
            {hasPermission('canManageEmployees') && <Route path="/employees" element={<Employees />} />}
            {hasPermission('canManageAssignments') && <Route path="/assignments" element={<AssetAssignments />} />}
            {hasPermission('canManageRepairs') && <Route path="/repairs" element={<Repairs />} />}
            {hasPermission('canManageUsers') && <Route path="/users" element={<Users />} />}
            {hasPermission('canManageUsers') && <Route path="/ai-search" element={<AiSearchChat />} />}
            {user?.role === 'Admin' && <Route path="/audit-logs" element={<AuditLogs />} />}
            <Route path="/help" element={<Help />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
